Cart = window.Cart ?= {}
InlineVariations = window.InlineVariations ?= {}
InlineVariations.Views ?= {}

DealEventPipe = require '../../../deal/frontend/event_pipe'
Cart.Helpers = require '../../../cart/common/helpers'

InlineVariations.Views.Main = Backbone.View.extend
  el: '#inline-variations-container'

  body: 'body'
  inlineVariationsTraits: '.inline-variation-trait'
  inlineVariationsDropdowns: '.inline-variation-layout-generic-dropdown, .inline-variation-native-dropdown'

  touch:
    main: '.t-main'
    featuredImg: '#featured-image'
    featuredImgSize: 't300x182.jpg'
    buyButton: '#buy'
    priceBuy: '#price-buy, #price-buy-v2'
    values: '#price-buy .value, #price-buy-v2 .value'
    prices: '#price-buy .price, #price-buy-v2 .price, #inline-variations-filters-header .price'
    urgencyPrice: '#price-buy .urgency-pricing-value-unit strong, #price-buy-v2 .urgency-pricing-value-unit strong'
    urgencyOfferLabel: '#price-buy .urgency-pricing-value-unit .urgency-pricing-offer-label, #price-buy-v2 .urgency-pricing-value-unit .urgency-pricing-offer-label'
    deliveryEstimate: '.delivery-estimates-container'
    discount: '#discount-percent span, .discount-percentage'
    savings: '#discount-savings span'
    filters: '#inline-variations-filters'
    filtersHeight: '48%'

  initialize: ->
    @$el ?= $(@el)
    _.extend this, @options

    @$inlineVariationsDropdowns = @$el.find @inlineVariationsDropdowns
    @$inlineVariationsTraits = @$el.find @inlineVariationsTraits
    @$body = $(@body)

    if @isTouch
      @$body = $(@touch.main)
      @$touchFeaturedImg = $(@touch.featuredImg)
      @$touchBuyButton = $(@touch.buyButton)
      @$touchPriceBuy = $(@touch.priceBuy)
      @$touchPrices = $(@touch.prices)
      @$touchValues = $(@touch.values)
      @$touchUrgencyPrice = $(@touch.urgencyPrice)
      @$touchUrgencyOfferLabel = $(@touch.urgencyOfferLabel)
      @$touchDeliveryEstimate = $(@touch.deliveryEstimate)
      @$touchDiscount = $(@touch.discount)
      @$touchSavings = $(@touch.savings)
      @$touchFilters = $(@touch.filters)

      @touchOriginalFeaturedImg = @$touchFeaturedImg.attr 'src'

    @attachBackdropEventListener()
    @makeSelectionsViaPreselection()

  attachBackdropEventListener: ->
    @$body.click (e) =>
      return unless @$body.hasClass 'inline-variation-backdrop'
      if @$body.hasClass 'stop-propagation'
        @$body.removeClass 'stop-propagation'
      else
        @traits.closeDropdowns()
        if @isTouch
          @$touchFilters.animate height: '0', 400, 'swing', =>
            @$body.removeClass 'inline-variation-backdrop'
            @$touchFilters.height 'auto'
            @_scrollToTouchInlineVariation()
        else
          @$body.removeClass 'inline-variation-backdrop'
  makeSelectionsViaPreselection: ->
    return unless @preSelectTraits?.length
    return unless option = @options.findWhere uuid: @dealOptionUuid

    selections = {}
    for trait in @preSelectTraits
      selections[trait] = value if value = option.get(trait)

    @updateSelections selections
    @render()

  render: (updateCarouselOrFeaturedImage = true) ->
    @updateSoldout()
    @updatePriceAndBuyButton()
    @updateCarouselOrFeaturedImage() if updateCarouselOrFeaturedImage
    @hideErrorMessages()

  updateSoldout: ->
    return if @traits.models.length < 2

    for trait in @traits.models
      filteredSelection = _.omit @traits.selectedTraitValues, trait.get('name')

      for traitValue in trait.get('values') or []
        continue if traitValue.isPlaceholder

        currentValue = {}
        currentValue[traitValue.traitName] = traitValue.name

        trait.view.toggleSoldOut traitValue, @options.where(_.extend filteredSelection, currentValue).length is 0

  updatePriceAndBuyButton: ->
    qualifiedOptions = @getQualifiedOptions()
    return unless qualifiedOptions.length
    return unless cheapestOption = _.min qualifiedOptions, (option) -> option.get('amount')
    return if cheapestOption is Infinity

    optionInfo =
      buyUrl: @buyButtonUrl cheapestOption
      hideOriginalPriceAndDiscount: cheapestOption.get('hideOriginalPriceAndDiscount')
      id: cheapestOption.get('id')
      lengthClass: cheapestOption.get('lengthClass')
      percent: cheapestOption.get('discount')
      price: cheapestOption.get('newPrice')
      savings: cheapestOption.get('savePrice')
      uuid: cheapestOption.get('uuid')
      value: cheapestOption.get('oldPrice')
      variationsSelected: qualifiedOptions.length is 1 and @traits.allTraitValuesSelected()

    @overridePrice optionInfo, cheapestOption

    if @isTouch
      @updateTouchDealInfo optionInfo
      @updateTouchBuyButton optionInfo
      DealEventPipe.trigger "touchDeliveryEstimatesUpdate", optionInfo
    else
      DealEventPipe.trigger "priceUpdate", optionInfo

  updateTouchDealInfo: ({id, percent, price, sale, savings, uuid, value}) ->
    @$touchValues.text value
    @$touchDiscount.html percent
    @$touchSavings.text savings
    @$touchPriceBuy.attr 'data-option-id', id

    if urgencyPricing = sale?.urgencyPricing
      @$touchPrices.text urgencyPricing.regularPrice
      @$touchUrgencyPrice.show().text urgencyPricing.newPrice
      @$touchPriceBuy.addClass 'urgency-pricing-cluster'

      if urgencyPricing.pricingMetadata?.offerLabel
        @$touchUrgencyOfferLabel.show().text urgencyPricing.pricingMetadata.offerLabel
      else
        @$touchUrgencyOfferLabel.hide()
    else
      @$touchPrices.text price
      @$touchPriceBuy.removeClass 'urgency-pricing-cluster'

  updateTouchBuyButton: ({buyUrl, id, variationsSelected}) ->
    if variationsSelected
      @$touchBuyButton.attr 'href', buyUrl
      @$touchBuyButton.attr('data-option', id) if @isCart
    else
      @$touchBuyButton.removeAttr 'href'
      @$touchBuyButton.removeAttr('data-option') if @isCart

  getQualifiedOptions: ->
    if @traits.someTraitValuesSelected()
      @options.where @traits.selectedTraitValues
    else
      @options.models

  variationsSelected: ->
    qualifiedOptions = @getQualifiedOptions()
    qualifiedOptions.length is 1 and @traits.allTraitValuesSelected()

  buyButtonUrl: (option) ->
    switch
      when option.get('externalUrl')?.length
        option.get('externalUrl')
      when @isCart
        Cart.Helpers.generateCartUrl option.get('uuid'), @dealUuid
      else
        option.get('url')

  overridePrice: (optionInfo, option) ->
    return unless option.get('regularPrice')? or @offer?.offerOptions?.length
    sale = {}
    if option.get('regularPrice')
      sale.urgencyPricing =
        newPrice: option.get('newPrice')
        pricingMetadata: option.get('pricingMetadata')
        regularPrice: option.get('regularPrice')

    if offer = _.findWhere @offer?.offerOptions, {id: option.get('uuid')}
      optionInfo.buyUrl = offer.buyUrl if offer.buyUrl and not @offer.offerModal?.isSoldOut
      _.extend sale, {offer}

    _.extend optionInfo, {sale} if sale isnt {}

  updateCarouselOrFeaturedImage: ->
    if @isTouch
      @$touchFeaturedImg.attr 'src', imageUrl if imageUrl = @findFeaturedImageUrl()
    else if image = @findCarouselImage()
      currentBaseUrl = @carouselViews[@dealUuid].currentFeatured.baseURL
      @carouselViews[@dealUuid].updateGallery image if currentBaseUrl isnt image.baseURL

  findFeaturedImageUrl: ->
    return @touchOriginalFeaturedImg unless image = @options.findWhere(@traits.selectedTraitValues)?.get('image')
    "#{image}#{@touch.featuredImgSize}"

  findCarouselImage: ->
    return @dealMedia[@dealUuid].models[0] unless @traits.someTraitValuesSelected()

    for imageUrl, valuesHash of @mappings
      foundMatch = _.every @traits.models, (trait) ->
        return true unless selectedTraitValue = trait.get('selectedTraitValue')
        _.contains valuesHash[trait.get('name')], selectedTraitValue

      if foundMatch
        @carouselImage = imageUrl
        return @dealMedia[@dealUuid].findWhere {baseURL: imageUrl}

  updateInlineVariationSelections: (image) ->
    return unless image
    return if image is @carouselImage

    @carouselImage = image

    selections = {}
    if @mappings[image]
      for key, value of @mappings[image]
        selections[key] = value[0] if value.length is 1

    @updateSelections selections
    @render false

  updateSelections: (selections) ->
    for trait in @traits.models
      trait.setSelectedTraitValueByName selections[trait.get('name')]

  showErrorMessages: ->
    @$el.addClass 'error'
    for trait in @traits.models
      trait.view.showErrorMessages()

  hideErrorMessages: ->
    @$el.removeClass 'error'
    for trait in @traits.models
      trait.view.hideErrorMessages()

  showBackdrop: (traitView) ->
    isOpen = @$body.hasClass 'inline-variation-backdrop'
    @$body.addClass 'inline-variation-backdrop stop-propagation'

    return unless @isTouch

    if isOpen
      traitView.slideDownAnimation()
    else
      @$touchFilters.animate {height: @touch.filtersHeight}, ->
        traitView.slideDownAnimation()

module.exports = InlineVariations.Views.Main
